import React from "react";
import { ImgContainer } from "./index.styled";

const HeroPic = () => {
  return (
    <ImgContainer>
      <img src={"man.png"} alt="avanegar" />
    </ImgContainer>
  );
};

export default HeroPic;
